import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDesignerStore } from "@/components/designer/store";
import { useAuth } from "@/lib/auth";
import { designerEngine } from "@/components/designer/engine/DesignerEngine";
import { saveCurrentDesign } from "./saveDesign";

export default function StudioToolbar() {
  const { user } = useAuth();
  const product = useDesignerStore((s) => s.product);
  const side = useDesignerStore((s) => s.side);
  const navigate = useNavigate();
  const [status, setStatus] = useState("");

  async function save() {
    if (!user) {
      navigate("/login");
      return;
    }
    if (!designerEngine.getCanvas()) return;
    const name = window.prompt("Name this design:", `${product} design`);
    if (!name) return;

    setStatus("Saving…");
    try {
      await saveCurrentDesign(product, name);
      setStatus("Saved ✓ — see it under My Account → Designs");
    } catch (e: any) {
      setStatus(e.message || "Save failed");
    }
  }

  return (
    <div className="rounded-2xl bg-[#141d2e] border border-slate-700 p-5 flex items-center justify-between flex-wrap gap-4">
      <div>
        <h1 className="text-3xl font-black text-white">CTSB Studio</h1>
        <p className="text-slate-400">Professional Garment Designer</p>
        {status && <p className="text-cyan-400 text-sm mt-1">{status}</p>}
      </div>

      <div className="flex gap-3 items-center flex-wrap">
        {product === "tshirt" && (
          <div className="flex rounded-xl bg-slate-800 border border-slate-600 overflow-hidden">
            {(["front", "back"] as const).map((s) => (
              <button
                key={s}
                onClick={() => designerEngine.switchSide("tshirt", s)}
                className={`px-5 py-3 font-bold uppercase text-sm transition ${
                  side === s ? "bg-cyan-600 text-white" : "text-slate-300 hover:bg-slate-700"
                }`}
              >
                {s}
              </button>
            ))}
          </div>
        )}
        <button
          onClick={() => designerEngine.undo()}
          className="px-5 py-3 rounded-xl bg-slate-700 text-white hover:bg-slate-600"
        >
          ↶ Undo
        </button>
        <button
          onClick={() => designerEngine.redo()}
          className="px-5 py-3 rounded-xl bg-slate-700 text-white hover:bg-slate-600"
        >
          ↷ Redo
        </button>
        <button onClick={save} className="px-5 py-3 rounded-xl bg-cyan-600 text-white hover:bg-cyan-500">
          💾 {user ? "Save" : "Sign in to save"}
        </button>
      </div>
    </div>
  );
}
